import Tray from '../Tray';
import { LocationsType } from '../types';
import {
    buildContainerClass,
    BASE_STYLE,
    CENTER_CONTAINERS_STYLE
} from './constants';

/**
 * A toaster container element.
 */
export default class ToastContainer {
    private readonly location: LocationsType;
    tray?: HTMLUListElement;
    element: HTMLElement;

    constructor(location: LocationsType) {
        this.location = location;
        this.element = this.create();
    }

    get style() {
        switch (this.location) {
            case 'top-start':
                return {
                    ...BASE_STYLE,
                    top: 0,
                    left: 0
                };
            case 'top':
                return {
                    ...BASE_STYLE,
                    ...CENTER_CONTAINERS_STYLE,
                    top: 0
                };
            case 'top-end':
                return {
                    ...BASE_STYLE,
                    top: 0,
                    right: 0
                };
            case 'bottom-start':
                return {
                    ...BASE_STYLE,
                    bottom: 0,
                    left: 0
                };
            case 'bottom':
                return {
                    ...BASE_STYLE,
                    ...CENTER_CONTAINERS_STYLE,
                    bottom: 0
                };
            case 'bottom-end':
                return {
                    ...BASE_STYLE,
                    bottom: 0,
                    right: 0
                };
            default:
                return { ...BASE_STYLE };
        }
    }

    addClassNames(element: HTMLElement) {
        if (this.location) {
            element.classList.add(buildContainerClass(this.location));
        }
    }

    /**
     * Generates a container element.
     */
    create() {
        const container = document.createElement('article');

        this.addClassNames(container);

        Object.assign(container.style, {
            ...BASE_STYLE,
            ...this.style
        });

        this.tray = new Tray(this.location).element;
        container.appendChild(this.tray);

        return container;
    }
}
